import { AbstractRoomContentModel } from "@app/catalog-common";


export class SelectRoomContentMessage {
  selected: AbstractRoomContentModel;

  constructor(selected: AbstractRoomContentModel) {
    if (selected != undefined) {
      this.selected = selected;
    }
  }
}